__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['axp-gravity-page-wrapper'].baseUrl;
import ModuleContainer from './components/GravityPageWrapper';
export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "5.x || 6.x"
  });
}
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    requiredExternals: {
      '@americanexpress/gravity-core': '^2.2.0'
    }
  });
}